<lui-context-menu-container [opened]="isOpen" class="z-2">
  <button
    [luiContextMenuButtonFor]
    [matMenuTriggerFor]="contextMenu"
    luiPreventBubble
    aria-label="More"
    i18n-aria-label
  >
    <mat-icon svgIcon="more"></mat-icon>
  </button>

  <lui-context-menu>
    <ng-container *ngFor="let action of inlineActions">
      <ng-container [ngSwitch]="action.type">
        <ng-container *ngSwitchCase="'link'">
          <a
            *ngIf="guards.isLink(action)"
            luiCab
            luiContextMenuItem
            luiPreventBubble
            [routerLink]="action.link?.path"
            [queryParams]="action.link?.queryParams"
            [fragment]="action.link?.fragment"
            [matTooltip]="action.label"
          >
            <mat-icon [svgIcon]="action.icon"></mat-icon>
          </a>
        </ng-container>

        <ng-container *ngSwitchCase="'inlineComponent'">
          <ng-container *ngIf="guards.isInlineComponent(action)">
            <button
              luiCab
              luiContextMenuItem
              luiPreventBubble
              cdkOverlayOrigin
              [matTooltip]="action.label"
              #trigger="cdkOverlayOrigin"
              (click)="
                setInlineComponent(action.inlineComponent.id, $any(entity).id)
              "
            >
              <mat-icon [svgIcon]="action.icon"></mat-icon>
            </button>

            <ng-template
              cdkConnectedOverlay
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayHasBackdrop]="true"
              [cdkConnectedOverlayOpen]="
                inlineComponentId === action.inlineComponent.id
              "
              (backdropClick)="setInlineComponent()"
            >
              <div class="bg-white selector-container rounded p-1">
                <ndc-dynamic
                  [ndcDynamicComponent]="action.inlineComponent.component"
                  [ndcDynamicInputs]="action.inlineComponent.inputs || {}"
                  [ndcDynamicOutputs]="action.inlineComponent.outputs || {}"
                ></ndc-dynamic>
              </div>
            </ng-template>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <button
            luiCab
            luiContextMenuItem
            luiPreventBubble
            [id]="action.id"
            (click)="childOutput.emit({ id: action.id, event: entity })"
            [matTooltip]="action.label"
          >
            <mat-icon [svgIcon]="action.icon"></mat-icon>
          </button>
        </ng-container>
      </ng-container>
    </ng-container>

    <mat-menu #contextMenu="matMenu" [xPosition]="'before'">
      <ng-container *ngFor="let action of allActions">
        <ng-container [ngSwitch]="action.type">
          <ng-container *ngSwitchCase="'link'">
            <a
              *ngIf="guards.isLink(action)"
              mat-menu-item
              [routerLink]="action.link?.path"
              [queryParams]="action.link?.queryParams"
              [fragment]="action.link?.fragment"
              [matTooltip]="action.label"
              id="{{action.id}}"
            >
              <mat-icon [svgIcon]="action.icon"></mat-icon>
              <span>{{ action.label }}</span>
            </a>
          </ng-container>

          <!-- TODO -->
          <ng-container *ngSwitchCase="'inlineComponent'"></ng-container>

          <button
            *ngSwitchDefault
            mat-menu-item
            [id]="action.id"
            (click)="childOutput.emit({ id: action.id, event: entity })"
          >
            <mat-icon [svgIcon]="action.icon"></mat-icon>
            {{ action.label }}
          </button>
        </ng-container>
      </ng-container>
    </mat-menu>
  </lui-context-menu>
</lui-context-menu-container>
